module.exports = __webpack_public_path__ + "static/gallery-12-1779d78da9a23a1cfd15633a89daa30b.jpg";